import { memo } from "react";

const bachelorStatusMapping = {
	"Nội bộ": {
		style: "bg-[#458FCD] text-white",
		title: "Chưa đẩy lên Cổng quốc tịch",
	},
	"Đang gửi": {
		style: "bg-[#FFC543] text-black",
		title: "Đang gửi dữ liệu…",
	},
	"Đã xác nhận": {
		style: "bg-[#00664F] text-white",
		title: "Đã đồng bộ thành công",
	},
	"Đã thu hồi": {
		style: "bg-[#3A387D] text-white",
		title: "Văn bằng đã thu hồi",
	},
};

export const StatusBadge = memo(({ name }: { name: keyof typeof bachelorStatusMapping }) => {
	return bachelorStatusMapping[name] ? (
		<div title={bachelorStatusMapping[name].title} className={`${bachelorStatusMapping[name].style} inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors`}>
			{name}
		</div>
	) : (
		<div className={`bg-slate-400 text-white inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors`}>Không xác định</div>
	);
});
